module.exports = __webpack_public_path__ + "static/media/attachment.08e048bd.svg";